export const QUIZ_OBJECT_NAME = 'quiz__a';
export const TRAINING_ASSIGNMENT_OBJECT_NAME = 'training_assignment__a';
export const COURSE_OBJECT_NAME = 'course__a';
